"use client";

import { Suspense } from "react";
import InvoiceEditor from "@/components/Invoice/InvoiceEditor";
import { Loading } from "@/components/Invoice/ui";

export default function EditInvoicePage() {
  return (
    <Suspense fallback={<Loading />}>
      <InvoiceEditor />
    </Suspense>
  );
}
